export const resources = {
  en: {
    translation: {
      'Welcome to Horse Trader': 'Welcome to Horse Trader',
      'Dashboard Text': 'Dashboard content goes here',
      'Mytools Text': 'Remove all these when My Tools dev begins',
      'Reservation Text': 'Reservation content goes here',
      'Profile Text': 'Profile content goes here',
      'Dispatch Text': 'Dispatch goes here',
      'Map Text': 'Map View goes here',
      'Dashboard Title': 'Dashboard',
      'My Tools Title': 'My Tools',
      'Reservation Title': 'Reservations',
      'Profile Title': 'Profile',
      'Map Title': 'Map',
      'Dispatch Title': 'Dispatch',
      'Tool Transfer Title': 'Tool Transfer',
      'Inventory Title': 'Inventory',
      'Returns Title': 'Return',
      'Select Reservation': 'Please select a reservation to view details',
      Open: 'Open',
      Completed: 'Completed',
      'Out Of Stock': 'Out Of Stock',
      Cancelled: 'Cancelled',
      'In hand (Reserved)': 'In hand (Reserved)',
      Tools: 'Tools',
      INVALID_REQUIRED_START_DATE: 'The required date should be from 2 days from now',
      FAILED_TO_UPDATE_TOOL_ORDER: 'Tool Order Failed to Update',
      REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID: 'Tool order recipient does not have a tool hound ID',
      INVALID_ADVANCEMENT_OF_TOOL_ORDER: 'Tool Order Failed to Advance',
      INVALID_TOOL_ROOM_ID: 'Invalid Tool Room ID',
      ORDER_DATE_REQUIRED_AFTER_DRAFT: 'Order Date Required After Draft',
      TOOL_ORDER_NOT_FOUND: 'Tool Order is Not Found',
      ALREADY_PREPARED: 'Reservation already in Prepared state.',
      FAILED_TO_DISPATCH_ORDER: 'Reservation failed to process',
      PICKED_QUANTITY_IS_GREATER: 'One or more items picked are no longer avialable to issue.',
      TOOL_ORDER_CATALOG_DATA_NOT_FOUND: 'Item(s) not found',
      USER_DOESNT_HAVE_OUTBOUND_USER_ID: 'Tool Hound User ID not found.',
      CATALOG_QUANTITY_CAN_NOT_BE_ZERO: 'Catalog quantity can not be 0',
      DRAFT_ALREADY_EXIST: 'Draft already exists',
      FAILED_TO_INSERT_TOOL_ORDER: 'Failed to create tool order',
      ORDER_LIMIT_EXEEDS: 'Order limit exeeds',
      ORDER_NO_ALREADY_EXIST: 'Order Number already exists',
      MISSING_REQUIRED_PERMISSION: 'You do not have required permission to perform this action.',
      'Adhoc Order For': 'Adhoc Order For',
      'History-PLACED': 'Reserved Tools',
      'History-OUTOFSTOCK': 'Out of Stock',
      'History-CANCELLED': 'Cancelled',
      'History-PREPARED': 'Prepared Tools',
      'History-COMPLETED': 'Completed',
      ON_HAND_COUNT_NOT_AVAILABLE: 'Picked Quantity is more than available quantity.',
      DEFAULT_ERROR: 'Some error occured.Please try again!',
      SERIALIZED_ITEM_QUANTITY_WILL_NOT_EXCEED_TO_1: 'Serialized Items cannot have a quantity greater than 1.',
      'Inactive!': 'Inactive!',
      NoToolHoundId: 'No Valid Tool Hound ID',
      DUPLICATE: 'Data already exist.',
      NO_CORRESPONDING_TH6_ROLE: 'No Corresponding tool hound role.',
      ITEM_NOT_FOUND: 'Item(s) not found',
      FAILED_TO_INSERT_TOOL_CHECK_IN: 'Something went wrong with the tool check-in. Please try again later',
      INVALID_BUN_OR_LOB_ID: 'The BUN or eTrackId is invalid. Please check the ID and try again',
      REPAIR_TOOL_ROOM_NOT_CONFIGURED:
        'Repair tool room configuration is missing. Please contact your system administrator',
      RECIPIENT_DOESNT_HAVE_TOOL_HOUND_ID: 'Recipient user does not have a valid Tool Hound ID  ',
      COMMON_ERROR_MESSAGE: 'Error occured while performing this action.Please try again!',
      DISPATCH_QUANTITY_GREATER_THAN_ORDER_QUANTITY: 'Dispatch quantity is greater than order quantity',
    },
  },
  es: {
    translation: {
      'Welcome to Horse Trader': 'Bienvenido a Comerciante de Caballos',
      'Dashboard Text': 'El contenido del panel va aquí',
      'Mytools Text': 'Elimine todo esto cuando comience el desarrollo de Mis herramientas',
      'Reservation Text': 'El contenido de la reserva va aquí',
      'Profile Text': 'El contenido del perfil irá aquí',
      'Dispatch Text': 'El envío va aquí',
      'Map Text': 'La vista del mapa va aquí',
      'Dashboard Title': 'Salpicadero',
      'My Tools Title': 'Mis herramientas',
      'Reservation Title': 'Reservas',
      'Profile Title': 'Perfil',
      'Map Title': 'Mapa',
      'Dispatch Title': 'Despacho',
      'Tool Transfer Title': 'Tool Transfer',
      'Inventory Title': 'Inventory',
      'Returns Title': 'Devolver',
      'Select Reservation': 'Por favor, seleccione una reserva para ver los detalles',
      Open: 'Abierto',
      Completed: 'Terminada',
      'Out Of Stock': 'Agotado',
      Cancelled: 'Cancelada',
      'In hand (Reserved)': 'In hand (Reserved)',
      Tools: 'Tools',
      INVALID_REQUIRED_START_DATE: 'La fecha requerida debe ser dentro de 2 días a partir de ahora',
      FAILED_TO_UPDATE_TOOL_ORDER: 'No se pudo actualizar el orden de las herramientas',
      REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID: 'El destinatario del pedido de herramientas no tiene un ID de Tool Hound',
      INVALID_ADVANCEMENT_OF_TOOL_ORDER: 'El pedido de herramientas no pudo avanzar',
      INVALID_TOOL_ROOM_ID: 'ID de sala de herramientas no válido',
      ORDER_DATE_REQUIRED_AFTER_DRAFT: 'Fecha de pedido requerida después del borrador',
      TOOL_ORDER_NOT_FOUND: 'No se encuentra el pedido de herramientas',
      ALREADY_PREPARED: 'Reserva ya en estado Preparado.',
      FAILED_TO_DISPATCH_ORDER: 'La reserva no se pudo procesar',
      PICKED_QUANTITY_IS_GREATER: 'Uno o más artículos seleccionados ya no están disponibles para su emisión.',
      TOOL_ORDER_CATALOG_DATA_NOT_FOUND: 'Artículo(s) no encontrado(s)',
      USER_DOESNT_HAVE_OUTBOUND_USER_ID: 'No se encontró el ID de usuario de Tool Hound.',
      CATALOG_QUANTITY_CAN_NOT_BE_ZERO: 'La cantidad del catálogo no puede ser 0',
      DRAFT_ALREADY_EXIST: 'el borrador ya existe',
      FAILED_TO_INSERT_TOOL_ORDER: 'No se pudo crear el pedido de herramientas',
      ORDER_LIMIT_EXEEDS: 'El límite de pedidos supera',
      ORDER_NO_ALREADY_EXIST: 'El número de pedido ya existe',
      'Adhoc Order For': 'Orden ad hoc para',
      SERIALIZED_ITEM_QUANTITY_WILL_NOT_EXCEED_TO_1:
        'Los Artículos Serializados no pueden tener una cantidad mayor a 1.',
      'Inactive!': 'Inactivo!',
      NoToolHoundId: 'No hay una identificación válida de Tool Hound',
      ITEM_NOT_FOUND: 'Artículo(s) no encontrado(s)',
      FAILED_TO_INSERT_TOOL_CHECK_IN:
        'Algo salió mal con el registro de la herramienta. Por favor, inténtelo de nuevo más tarde',
      INVALID_BUN_OR_LOB_ID: 'El BUN o eTrackId no es válido. Compruebe el ID e inténtelo de nuevo',
      REPAIR_TOOL_ROOM_NOT_CONFIGURED:
        'Falta la configuración de la sala de herramientas de reparación. Póngase en contacto con el administrador del sistema',
    },
  },
  hi: {
    translation: {
      'Welcome to Horse Trader': 'घोड़ा व्यापारी में आपका स्वागत है',
      'Dashboard Text': 'डैशबोर्ड सामग्री यहां जाएगी',
      'Mytools Text': 'माई टूल्स डेव शुरू होने पर इन सभी को हटा दें',
      'Reservation Text': 'आरक्षण सामग्री यहां जाएगी',
      'Profile Text': 'प्रोफ़ाइल सामग्री यहां जाएगी',
      'Dispatch Text': 'Dispatch goes here',
      'Map Text': 'Map View goes here',
      'Dashboard Title': 'डैशबोर्ड',
      'My Tools Title': 'उपकरण',
      'Reservation Title': 'आरक्षण',
      'Profile Title': 'प्रोफ़ाइल',
      'Map Title': 'Mapa',
      'Dispatch Title': 'Dispatch',
      'Tool Transfer Title': 'Tool Transfer',
      'Inventory Title': 'Inventory',
      'Returns Title': 'Return',
      Open: 'Open',
      Completed: 'Completed',
      'Out Of Stock': 'Out Of Stock',
      Cancelled: 'Cancelled',
      'In hand (Reserved)': 'In hand (Reserved)',
      Tools: 'Tools',
      INVALID_REQUIRED_START_DATE: 'आवश्यक तिथि अब से 2 दिन बाद की होनी चाहिए',
      ON_HAND_COUNT_NOT_AVAILABLE: 'चुनी गई मात्रा उपलब्ध मात्रा से अधिक है|',
      SERIALIZED_ITEM_QUANTITY_WILL_NOT_EXCEED_TO_1: 'क्रमबद्ध आइटम की मात्रा 1 से अधिक नहीं हो सकती।',
    },
  },
};
